import React, { Component } from "react";
import DashboardComp from "../../components/Dashboard/DashboardComp/DashboardComp";
export default class Dashboard extends Component {
  render() {
    return (
      <DashboardComp/>
    );
  }
}
